import { db } from "@/services/firebase/config";
import firebase from "firebase/compat/app";

interface CancellationRequestData {
  document: string;
  reason: string;
  createdAt: any; // firebase.firestore.FieldValue ou Timestamp
  status: "pending" | "approved" | "rejected";
}

class RequestAccountCancellation {
  execute = async (document: string, reason: string) => {
    try {
      console.log("📝 Iniciando solicitação de cancelamento...");
      console.log("   Documento:", document);
      console.log("   Motivo:", reason.substring(0, 50) + "...");

      const cancellationRequest: Omit<CancellationRequestData, "createdAt"> & {
        createdAt: any;
      } = {
        document: document,
        reason: reason,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        status: "pending",
      };

      console.log("💾 Salvando no Firestore...");
      console.log("   Coleção: accountCancellations");
      console.log("   Dados:", {
        document: cancellationRequest.document,
        reason: cancellationRequest.reason.substring(0, 50) + "...",
        status: cancellationRequest.status,
      });

      const docRef = await db.collection("accountCancellations").add(cancellationRequest);

      console.log("✅ Documento criado com sucesso!");
      console.log("   Document ID:", docRef.id);
      console.log("   Path:", docRef.path);

      // Verificar se o documento foi realmente criado
      const docSnapshot = await docRef.get();
      if (docSnapshot.exists) {
        console.log("✅ Confirmação: Documento existe no Firestore");
        console.log("   Dados salvos:", docSnapshot.data());
      } else {
        console.warn("⚠️ Aviso: Documento não encontrado após criação");
      }

      return {
        id: docRef.id,
        document: cancellationRequest.document,
        reason: cancellationRequest.reason,
        status: cancellationRequest.status,
      };
    } catch (error: any) {
      console.error("❌ Erro ao criar solicitação de cancelamento:");
      console.error("   Tipo:", error.name);
      console.error("   Mensagem:", error.message);
      console.error("   Código:", error.code);
      console.error("   Stack:", error.stack);
      throw error;
    }
  };
}

export { RequestAccountCancellation };

